// extracted by extract-css-chunks-webpack-plugin
module.exports = {"paymentItemWrapper":"_6s7fe","cardWrapper":"-r-Xn","imageBlock":"SyXfv","lastFourNumber":"ADfzW","visaLastFourNumber":"xOrDy"};